import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductList from '../../components/DynamicListGrid/DynamicListGrid';
import {getStoredData} from "../../JsonFiles/fetchData";
import { useNavigate } from 'react-router-dom';

const AdminHiring = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminHiring : {};

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/hiring');
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching actvities:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading hiring...</p>;
  }

  return (
    <div className="admin-products">
      <h2>Hiring List</h2>
      <button onClick={() => navigate('/admin/add-hiring')}>
        Create New Hiring
      </button>
      <ProductList products={products} fields={fields} redirect={totalData[12].AdminHiringEdit} deleteApi="https://shahbad-enterprises-backend.vercel.app/hiring"/>
    </div>
  );
};

export default AdminHiring;

